import React, { useState, useEffect } from 'react';
import { TicketCategory, TicketSite } from '../../../entities/ticket';
import { getTicketCategories } from '../../../entities/ticket/api/ticketApi';
import * as S from './CategoriesModal.styles';

interface CategoriesModalProps {
  isOpen: boolean;
  onClose: () => void;
  onSelect: (category: string) => void;
  currentSite: TicketSite;
  currentCategory?: string;
}

export const CategoriesModal: React.FC<CategoriesModalProps> = ({
  isOpen,
  onClose,
  onSelect,
  currentSite,
  currentCategory,
}) => {
  const [categories, setCategories] = useState<TicketCategory[]>([]);
  const [searchQuery, setSearchQuery] = useState('');
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (isOpen) {
      loadCategories();
    }
  }, [isOpen, currentSite]);

  const loadCategories = async () => {
    try {
      setLoading(true);
      const data = await getTicketCategories(currentSite);
      setCategories(data);
    } catch (error) {
      console.error('Ошибка загрузки категорий:', error);
    } finally {
      setLoading(false);
    }
  };

  const filteredCategories = categories.filter(cat =>
    cat.name.toLowerCase().includes(searchQuery.toLowerCase())
  );

  const handleSelect = (category: string) => {
    onSelect(category);
    onClose();
  };

  if (!isOpen) return null;

  return (
    <S.ModalOverlay onClick={onClose}>
      <S.ModalContent onClick={(e) => e.stopPropagation()}>
        <S.ModalHeader>
          <S.ModalTitle>Выберите категорию</S.ModalTitle>
          <S.CloseButton onClick={onClose}>×</S.CloseButton>
        </S.ModalHeader>

        <S.SearchInput
          type="text"
          placeholder="Поиск категории..."
          value={searchQuery}
          onChange={(e) => setSearchQuery(e.target.value)}
        />

        <S.CategoriesList>
          {loading ? (
            <S.LoadingText>Загрузка...</S.LoadingText>
          ) : filteredCategories.length === 0 ? (
            <S.EmptyText>Категории не найдены</S.EmptyText>
          ) : (
            filteredCategories.map(category => (
              <S.CategoryItem
                key={category.id}
                $selected={currentCategory === category.id}
                onClick={() => handleSelect(category.id)}
              >
                {category.name}
              </S.CategoryItem>
            ))
          )}
        </S.CategoriesList>
      </S.ModalContent>
    </S.ModalOverlay>
  );
};


